import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Button,
    CardTitle,
    CardSubtitle,
    Label,
    Input,
    Container,
    Form,
    FormFeedback,
    UncontrolledAlert,
    Spinner // Import Spinner component for loading indicator
} from "reactstrap";
import { useTranslation } from 'react-i18next';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useParams, useNavigate } from 'react-router-dom';
import AlertModal from "components/AlertModal";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Dummy from "../../assets/images/No_Image_Available.jpg";
import { get, put, del,post } from "../../Services/RestAPIService";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const FormValidations = () => {
    const animatedComponents = makeAnimated();
    const { t } = useTranslation();
    const navigate = useNavigate();
    // const { slug } = useParams();
    const [userData, setUserData] = useState('');
    const [occupations, setOccupations] = useState([
        { value: '', label: 'Select' },
        { value: 'Construction', label: 'Construction (e.g., bricklayer, labourer)' },
        { value: 'Sports', label: 'Sports (e.g., coach, professional athlete)' },
        { value: 'Services and Hospitality', label: 'Services and Hospitality (e.g., waiter, chef)' },
        { value: 'Office/Remote Work', label: 'Office/Remote Work (e.g., programmer, accountant)' },
        { value: 'Education', label: 'Education (e.g., teacher, librarian)' }
    ]);

    const [profileImage, setProfileImage] = useState(null);
    const [alert, setAlert] = useState({
        color: "",
        message: "",
        visible: false
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingDel, setIsLoadingDel] = useState(false);
    const [isAlertModal, setIsAlertModal] = useState(false);
    const [selectedActivities, setSelectedActivities] = useState(null);
    const [selectedFrequency, setselectedFrequency] = useState([]);

    const [activitiesOptions, setActivitiesOptions] = useState([{ value: 'Walking', label: 'Walking' },
    { value: 'Walking', label: 'Walking' },
    { value: 'Running', label: 'Running' },
    { value: 'Swimming', label: 'Swimming' },
    { value: 'Cycling', label: 'Cycling' },
    { value: 'Yoga', label: 'Yoga' },
    { value: 'Gym', label: 'Gym' },
    { value: 'Dancing', label: 'Dancing' },
    { value: 'Hiking', label: 'Hiking' }
]);


    // const getUsersData = async () => {
    //     try {
    //         const data = await get(`v1/users/${slug}/`);
    //         setUserData(data);
    //          if (data.activities) {
    //             const selectedActivities = data.activities.map(activity => ({
    //                 value: activity,
    //                 label: activity
    //             }));
    //             setSelectedActivities(selectedActivities);
    //             }

    //             if (data.frequency) {
    //                 setselectedFrequency(data.frequency);
    //                 }

    //         console.log('Error fetching user data:', data);

    //     } catch (error) {
    //         console.error('Error fetching user data:', error);
    //     }
    // };

    // useEffect(() => {
    //     getUsersData();
    //     setIsLoading(false);

    // }, []);



    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            firstname: userData.first_name ? userData.first_name : "",
            lastname: userData.last_name ? userData.last_name : "",
            email: userData.email ? userData.email : "",
            status: userData.status ? userData.status.toString() : "false",
            mobile: userData.mobile_number ? userData.mobile_number : "",
            gender: userData.gender ? userData.gender : "",
            profile_image: userData.profile_image ? userData.profile_image : "",
            // user_type: userData.user_type ? userData.user_type : "",
            age: userData.age ? userData.age : "",
            Have_you_had_any_previous_pathology: userData.Have_you_had_any_previous_pathology ? userData.Have_you_had_any_previous_pathology : "false",
            pathology_details: userData.pathology_details ? userData.pathology_details : "",
            Have_you_had_any_previous_accidents: userData.Have_you_had_any_previous_accidents ? userData.Have_you_had_any_previous_accidents : "false",
            accident_details: userData.accident_details ? userData.accident_details : "",
            Have_you_undergone_any_surgical_interventions: userData.Have_you_undergone_any_surgical_interventions ? userData.Have_you_undergone_any_surgical_interventions : "false",
            surgery_details: userData.surgery_details ? userData.surgery_details : "",
            // activities: userData.activities ? userData.activities : [],
            frequency: userData.frequency ? userData.frequency : [],
            occupation: userData.occupation ? userData.occupation : "",
            occupation_role: userData.occupation_role ? userData.occupation_role : "",
            can_perform_standing_exercises: userData.can_perform_standing_exercises ? userData.can_perform_standing_exercises : "false",
            can_perform_lying_exercises: userData.can_perform_lying_exercises ? userData.can_perform_lying_exercises : "false"
        },
        validationSchema: Yup.object({
            firstname: Yup.string()?.required(t("Please Enter Your First Name")),
            lastname: Yup.string()?.required(t("Please Enter Your Last Name")),
            email: Yup.string().email(t("Invalid email address")).required(t("Email is required")),
            status: Yup.string().required(t("Please select the status")),
            mobile: Yup.string().required(t("Please enter your mobile number")),
            gender: Yup.string().required(t("Please select your gender")),
            // user_type: Yup.string().required(t("Please select user type")),
            age: Yup.number()?.required(t("Please enter your age")),
            Have_you_had_any_previous_pathology: Yup.boolean().required(t("Please select if you had any previous pathology")),
            pathology_details: Yup.string().when('Have_you_had_any_previous_pathology', {
                is: true,
                then: Yup.string().required(t("Please enter pathology details"))
            }),
            Have_you_had_any_previous_accidents: Yup.boolean().required(t("Please select if you had any previous accidents")),
            accident_details: Yup.string().when('Have_you_had_any_previous_accidents', {
                is: true,
                then: Yup.string().required(t("Please enter accident details"))
            }),
            Have_you_undergone_any_surgical_interventions: Yup.boolean().required(t("Please select if you underwent any surgical interventions")),
            surgery_details: Yup.string().when('Have_you_undergone_any_surgical_interventions', {
                is: true,
                then: Yup.string().required(t("Please enter surgery details"))
            }),
            // activities: Yup.array().min(1, t("Please enter activities")),
            frequency: Yup.array().of(Yup.string()).required(1, t("Please enter frequency")),
            occupation: Yup.string().required(t("Please enter occupation")),
            occupation_role: Yup.string().required(t("Please enter occupation role")),
            can_perform_standing_exercises: Yup.boolean().required(t("Please select if you can perform standing exercises")),
            can_perform_lying_exercises: Yup.boolean().required(t("Please select if you can perform lying exercises"))
        }),

        onSubmit: async (values) => {
            console.log(values, "values")
            setIsLoading(true);
                // activities: values.activities,
            const data = {
                first_name: values.firstname,
                last_name: values.lastname,
                email: values.email,
                status: values.status,
                mobile_number: values.mobile,
                gender: values.gender,
                // user_type: values.user_type,
                // "username":"ssss",
                age: values.age,
                Have_you_had_any_previous_pathology: values.Have_you_had_any_previous_pathology,
                pathology_details: values.pathology_details,
                Have_you_had_any_previous_accidents: values.Have_you_had_any_previous_accidents,
                accident_details: values.accident_details,
                Have_you_undergone_any_surgical_interventions: values.Have_you_undergone_any_surgical_interventions,
                surgery_details: values.surgery_details,
                activities: selectedActivities.map(activitie => activitie.value),
                frequency: selectedFrequency.map(freq => freq),
                occupation: values.occupation,
                occupation_role: values.occupation_role,
                can_perform_standing_exercises: values.can_perform_standing_exercises,
                can_perform_lying_exercises: values.can_perform_lying_exercises,
                ...(profileImage && { profile_image: profileImage })
            };

            console.log(data,"data")
            try {
                const response = await post(`v1/dashboard-user/`, data, {
                    headers: { 'Content-Type': 'application/json' },
                    validateStatus: false
                });

                console.log(response, "response")


                if (response.status === 201) {
                    setAlert({
                        color: "success",
                        visible: true,
                        message: t("Data updated successfully!")
                    });
                  

                    setTimeout(() => {
                        setAlert({ visible: false });
                        navigate(`/users`)
                    }, 3000);
                } else {
                    let errorMessage = t("An error occurred while updating data.");

                    const errorData = response.data?.errors || {};
                    if (errorData.email) {
                        console.error("Email error:", errorData.email[0]);
                         errorMessage  = t("Error: User with this email already exists.");
                    }

                    setAlert({
                        color: "danger",
                        visible: true,
                        message: errorMessage
                    });
                    setTimeout(() => {
                        setAlert({ visible: false });
                    }, 3000);
                }
            } catch (error) {
                console.error('Error updating user data:', error);
                setAlert({
                    color: "danger",
                    visible: true,
                    message: t("Error Updating User Data")
                });
                setTimeout(() => {
                    setAlert({ visible: false });
                }, 3000);
            } finally {
                setIsLoading(false);
            }
        }
    });
    

    // validation.validateForm().then((errors) => {
    //     console.log("Validation errors:", errors);
    //     if (Object.keys(errors).length === 0) {
    //         console.log("No validation errors. Form can be submitted.");
    //     } else {
    //         console.log("Validation failed with errors:", errors);
    //     }
    // });
    const handleImageChange = (event) => {
        const file = event.target.files[0]; 
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setProfileImage(base64String);
            };
            reader.readAsDataURL(file);
        }
    };

    // const handleDelete = async (event) => {
    //     setIsLoadingDel(true);
    //     setIsAlertModal(false);

    //     try {
    //         const response = await del(`v1/users/${slug}/`);
    //         if (response.status <= 400) {
    //             setAlert({
    //                 color: "success",
    //                 visible: true,
    //                 message: t("User deleted successfully!")
    //             });
    //             setTimeout(() => {
    //                 setAlert({ visible: false });
    //                 navigate(`/users/`);
    //             }, 3000);
    //         } else {
    //             const errorMessage = response.data?.error || t("An error occurred while deleting user.");
    //             setAlert({
    //                 color: "danger",
    //                 visible: true,
    //                 message: errorMessage
    //             });
    //             setTimeout(() => {
    //                 setAlert({ visible: false });
    //             }, 3000);
    //         }
    //     } catch (error) {
    //         console.error('Error deleting user:', error);
    //         setAlert({
    //             color: "danger",
    //             visible: true,
    //             message: t("Error Deleting User")
    //         });
    //         setTimeout(() => {
    //             setAlert({ visible: false });
    //         }, 3000);
    //     } finally {
    //         setIsLoadingDel(false);
    //         setTimeout(() => {
    //             setAlert({ visible: false });
    //             navigate(`/users/`);
    //         }, 1500);
    //     }
    // }


    const handleFrequencyChange = (index, selectedOptions) => {
        const updatedFrequency = [...selectedFrequency]; // Create a copy of the existing array
        updatedFrequency[index] = selectedOptions; // Update the frequency at the specified index
        console.log(updatedFrequency)
        setselectedFrequency(updatedFrequency); // Update the state
        console.log(updatedFrequency,selectedFrequency)
    };


    return (
        <React.Fragment>
            {alert.visible && <UncontrolledAlert className="Alert_Additions_Log" color={alert.color}>{alert.message}</UncontrolledAlert>}
                <div className="page-content">
                    <Container fluid={true}>
                        <Breadcrumbs maintitle={t("Home")} title={t("Users")} titleLink="/users" breadcrumbItem={t("User Details")} />
                        <Row>
                            <Col lg={4}>
                                <Card>
                                    <CardBody>
                                        <div className="text-center">
                                            <img src={profileImage || userData.profile_image || Dummy} alt="Profile" className="rounded-circle img-thumbnail avatar-xl" />
                                        </div>
                                        <div className="text-center mt-3">
                                            <input
                                                type="file"
                                                id="file"
                                                style={{ display: "none" }}
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                            <label htmlFor="file" className="btn btn-primary">
                                                {t("Change Picture")}
                                            </label>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg={8}>
                                <Card>
                                    <CardBody>
                                        <CardTitle>{t("Edit User")}</CardTitle>
                                        <CardSubtitle className="mb-3">
                                            {t("You can Edit User Profile from here.")}
                                        </CardSubtitle>
                                        <Form onSubmit={validation.handleSubmit}>

                                            <Row>
                                                <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("First Name")}</Label>
                                                        <Input
                                                            name="firstname"
                                                            type="text"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.firstname || ""}
                                                            invalid={validation.touched.firstname && validation.errors.firstname}
                                                        />
                                                        {validation.touched.firstname && validation.errors.firstname && (
                                                            <FormFeedback type="invalid">{validation.errors.firstname}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Last Name")}</Label>
                                                        <Input
                                                            name="lastname"
                                                            type="text"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.lastname || ""}
                                                            invalid={validation.touched.lastname && validation.errors.lastname}
                                                        />
                                                        {validation.touched.lastname && validation.errors.lastname && (
                                                            <FormFeedback type="invalid">{validation.errors.lastname}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>


                                            <Row>
                                                <Col>

                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Email")}</Label>
                                                        <Input
                                                            name="email"
                                                            type="email"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.email || ""}
                                                            invalid={validation.touched.email && validation.errors.email}
                                                        />
                                                        {validation.touched.email && validation.errors.email && (
                                                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>

                                                <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Mobile Number")}</Label>
                                                        <Input
                                                            name="mobile"
                                                            type="text"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.mobile || ""}
                                                            invalid={validation.touched.mobile && validation.errors.mobile}
                                                        />
                                                        {validation.touched.mobile && validation.errors.mobile && (
                                                            <FormFeedback type="invalid">{validation.errors.mobile}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col>


                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Gender")}</Label>
                                                        <Input
                                                            type="select"
                                                            name="gender"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.gender || ""}
                                                            invalid={validation.touched.gender && validation.errors.gender}
                                                        >
                                                            <option value="">{t("Select Gender")}</option>
                                                            <option value="Male">{t("Male")}</option>
                                                            <option value="Female">{t("Female")}</option>
                                                            <option value="Other">{t("Other")}</option>
                                                        </Input>
                                                        {validation.touched.gender && validation.errors.gender && (
                                                            <FormFeedback type="invalid">{validation.errors.gender}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>

                                                {/* <div className="mb-3">
                                                <Label className="form-label">{t("User Type")}</Label>
                                                <Input
                                                    name="user_type"
                                                    type="text"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.user_type || ""}
                                                    invalid={validation.touched.user_type && validation.errors.user_type}
                                                />
                                                {validation.touched.user_type && validation.errors.user_type && (
                                                    <FormFeedback type="invalid">{validation.errors.user_type}</FormFeedback>
                                                )}
                                            </div> */}
                                                <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Age")}</Label>
                                                        <Input
                                                            name="age"
                                                            type="number"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.age || ""}
                                                            invalid={validation.touched.age && validation.errors.age}
                                                        />
                                                        {validation.touched.age && validation.errors.age && (
                                                            <FormFeedback type="invalid">{validation.errors.age}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Status")}</Label>
                                                        <Input
                                                            type="select"
                                                            name="status"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.status || ""}
                                                            invalid={validation.touched.status && validation.errors.status}
                                                        >
                                                            <option value="">{t("Select Status")}</option>
                                                            <option value="true">{t("Active")}</option>
                                                            <option value="false">{t("Inactive")}</option>
                                                        </Input>
                                                        {validation.touched.status && validation.errors.status && (
                                                            <FormFeedback type="invalid">{validation.errors.status}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <div className="mb-3">
                                                <Label className="form-label">{t("Have you had any previous pathology?")}</Label>
                                                <Input
                                                    type="select"
                                                    name="Have_you_had_any_previous_pathology"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.Have_you_had_any_previous_pathology || ""}
                                                    invalid={validation.touched.Have_you_had_any_previous_pathology && validation.errors.Have_you_had_any_previous_pathology}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    <option value="true">{t("Yes")}</option>
                                                    <option value="false">{t("No")}</option>
                                                </Input>
                                                {validation.touched.Have_you_had_any_previous_pathology && validation.errors.Have_you_had_any_previous_pathology && (
                                                    <FormFeedback type="invalid">{validation.errors.Have_you_had_any_previous_pathology}</FormFeedback>
                                                )}
                                            </div>

                                            {(validation.values.Have_you_had_any_previous_pathology === "true" || validation.values.Have_you_had_any_previous_pathology === true) ? (
                                                <div className="mb-3">
                                                    <Label className="form-label">{t("Pathology Details")}</Label>
                                                    <Input
                                                        name="pathology_details"
                                                        type="textarea"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.pathology_details || ""}
                                                        invalid={validation.touched.pathology_details && validation.errors.pathology_details}
                                                    />
                                                    {validation.touched.pathology_details && validation.errors.pathology_details && (
                                                        <FormFeedback type="invalid">{validation.errors.pathology_details}</FormFeedback>
                                                    )}
                                                </div>
                                            ):null}

                                            <div className="mb-3">
                                                <Label className="form-label">{t("Have you had any previous accidents?")}</Label>
                                                <Input
                                                    type="select"
                                                    name="Have_you_had_any_previous_accidents"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.Have_you_had_any_previous_accidents || ""}
                                                    invalid={validation.touched.Have_you_had_any_previous_accidents && validation.errors.Have_you_had_any_previous_accidents}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    <option value="true">{t("Yes")}</option>
                                                    <option value="false">{t("No")}</option>
                                                </Input>
                                                {validation.touched.Have_you_had_any_previous_accidents && validation.errors.Have_you_had_any_previous_accidents && (
                                                    <FormFeedback type="invalid">{validation.errors.Have_you_had_any_previous_accidents}</FormFeedback>
                                                )}
                                            </div>

                                            {(validation.values.Have_you_had_any_previous_accidents === "true" || validation.values.Have_you_had_any_previous_accidents === true )&& (
                                                <div className="mb-3">
                                                    <Label className="form-label">{t("Accident Details")}</Label>
                                                    <Input
                                                        name="accident_details"
                                                        type="textarea"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.accident_details || ""}
                                                        invalid={validation.touched.accident_details && validation.errors.accident_details}
                                                    />
                                                    {validation.touched.accident_details && validation.errors.accident_details && (
                                                        <FormFeedback type="invalid">{validation.errors.accident_details}</FormFeedback>
                                                    )}
                                                </div>
                                            )}

                                            <div className="mb-3">
                                                <Label className="form-label">{t("Have you undergone any surgical interventions?")}</Label>
                                                <Input
                                                    type="select"
                                                    name="Have_you_undergone_any_surgical_interventions"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.Have_you_undergone_any_surgical_interventions || ""}
                                                    invalid={validation.touched.Have_you_undergone_any_surgical_interventions && validation.errors.Have_you_undergone_any_surgical_interventions}
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    <option value="true">{t("Yes")}</option>
                                                    <option value="false">{t("No")}</option>
                                                </Input>
                                                {validation.touched.Have_you_undergone_any_surgical_interventions && validation.errors.Have_you_undergone_any_surgical_interventions && (
                                                    <FormFeedback type="invalid">{validation.errors.Have_you_undergone_any_surgical_interventions}</FormFeedback>
                                                )}
                                            </div>

                                            {(validation.values.Have_you_undergone_any_surgical_interventions === "true" || validation.values.Have_you_undergone_any_surgical_interventions ===  true) && (
                                                <div className="mb-3">
                                                    <Label className="form-label">{t("Surgery Details")}</Label>
                                                    <Input
                                                        name="surgery_details"
                                                        type="textarea"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.surgery_details || ""}
                                                        invalid={validation.touched.surgery_details && validation.errors.surgery_details}
                                                    />
                                                    {validation.touched.surgery_details && validation.errors.surgery_details && (
                                                        <FormFeedback type="invalid">{validation.errors.surgery_details}</FormFeedback>
                                                    )}
                                                </div>
                                            )}
                                            <Row>
                                                <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Activities")}</Label>

                                                        <Select
                                                            value={selectedActivities}
                                                            isMulti
                                                            // onChange={(selectedOptions) => setSelectedActivities(selectedOptions)}
                                                            onChange={(selectedOptions) => {
                                                                setSelectedActivities(selectedOptions);
                                                                validation.setFieldValue('activities', selectedOptions);
                                                            }}

                                                            options={activitiesOptions}
                                                            classNamePrefix="select2-selection"
                                                            closeMenuOnSelect={false}
                                                            components={animatedComponents}
                                                            isLoading={isLoading}
                                                        />




                                                        {/* <Input
                                                            name="activities"
                                                            type="select"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.activities || ""}
                                                            invalid={validation.touched.activities && validation.errors.activities}
                                                        >
                                                            <option value="">{t("Select")}</option>
                                                            <option value="Walking">{t("Walking")}</option>
                                                            <option value="Running">{t("Running")}</option>
                                                            <option value="Swimming">{t("Swimming")}</option>
                                                            <option value="Cycling">{t("Cycling")}</option>
                                                        </Input> */}

                                                        {validation.touched.activities && validation.errors.activities && (
                                                            <FormFeedback type="invalid">{validation.errors.activities}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>



                                            </Row>
                                            <Row>
                                        {selectedActivities && selectedActivities.map((Exercise, i) => (
                                            <Col key={i}>
                                                <div className="mb-3">
                                                    <Label className="form-label">{`Frequency of Activity ${Exercise.label}`}</Label>
                                                    <Input
                                                        type="select"
                                                        name={`frequency-${i}`}
                                                        value={selectedFrequency[i] || ""}
                                                        onChange={(e) => {
                                                            const selectedOptions = e.target.value;
                                                            handleFrequencyChange(i, selectedOptions);
                                                            validation.setFieldValue(`frequency-${i}`, selectedOptions);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        invalid={validation.touched[`frequency-${i}`] && validation.errors[`frequency-${i}`]}
                                                    >
                                                        <option value="">{t("Select")}</option>
                                                        <option value="Daily">{t("Daily")}</option>
                                                        <option value="Occasionally">{t("Occasionally")}</option>
                                                        <option value="Rarely">{t("Rarely")}</option>
                                                        <option value="Never">{t("Never")}</option>
                                                    </Input>
                                                    {validation.touched[`frequency-${i}`] && validation.errors[`frequency-${i}`] && (
                                                        <FormFeedback type="invalid">{validation.errors[`frequency-${i}`]}</FormFeedback>
                                                    )}
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>

                                            <Row>
                                                <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Occupation")}</Label>
                                                        <Input
                                                            name="occupation"
                                                            type="select"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.occupation || ""}
                                                            invalid={validation.touched.occupation && validation.errors.occupation}
                                                        >
                                                            {occupations.map((occupation, i) => (
                                                            <option value={`${occupation.value}`}>{t(`${occupation.label}`)}</option>))}

                                                        </Input>
                                                        {validation.touched.occupation && validation.errors.occupation && (
                                                            <FormFeedback type="invalid">{validation.errors.occupation}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>

                                                <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Occupation Role")}</Label>
                                                        <Input
                                                            name="occupation_role"
                                                            type="textarea"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.occupation_role || ""}
                                                            invalid={validation.touched.occupation_role && validation.errors.occupation_role}
                                                        />
                                                        {validation.touched.occupation_role && validation.errors.occupation_role && (
                                                            <FormFeedback type="invalid">{validation.errors.occupation_role}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Can perform standing exercises?")}</Label>
                                                        <Input
                                                            type="select"
                                                            name="can_perform_standing_exercises"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.can_perform_standing_exercises || ""}
                                                            invalid={validation.touched.can_perform_standing_exercises && validation.errors.can_perform_standing_exercises}
                                                        >
                                                            <option value="">{t("Select")}</option>
                                                            <option value="true">{t("Yes")}</option>
                                                            <option value="false">{t("No")}</option>
                                                        </Input>
                                                        {validation.touched.can_perform_standing_exercises && validation.errors.can_perform_standing_exercises && (
                                                            <FormFeedback type="invalid">{validation.errors.can_perform_standing_exercises}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col><Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Can perform lying exercises?")}</Label>
                                                        <Input
                                                            type="select"
                                                            name="can_perform_lying_exercises"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.can_perform_lying_exercises || ""}
                                                            invalid={validation.touched.can_perform_lying_exercises && validation.errors.can_perform_lying_exercises}
                                                        >
                                                            <option value="">{t("Select")}</option>
                                                            <option value="true">{t("Yes")}</option>
                                                            <option value="false">{t("No")}</option>
                                                        </Input>
                                                        {validation.touched.can_perform_lying_exercises && validation.errors.can_perform_lying_exercises && (
                                                            <FormFeedback type="invalid">{validation.errors.can_perform_lying_exercises}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <div className="d-flex flex-wrap gap-2">
                                                <Button type="submit" color="primary" disabled={isLoading || isLoadingDel}>
                                                    {isLoading ? (
                                                        <Spinner size="sm" color="light" />
                                                    ) : (
                                                        `${t("Submit")}`
                                                    )}
                                                </Button>{" "}
                                                {/* <Button onClick={() => { setIsAlertModal(true) }} color="danger" disabled={isLoading || isLoadingDel}>
                                                    {isLoadingDel ? (<Spinner size="sm" color="light" />
                                                    ) : (
                                                        `${t("Delete")}`
                                                    )}
                                                </Button>{" "} */}
                                                {isAlertModal && <AlertModal selection={(e) => { e === true ? handleDelete() : setIsAlertModal(false) }} Display={null} />}
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
  
        </React.Fragment>
    );
};

export default FormValidations;
